import { Map, Record } from "immutable";

interface DspsInternalState {
    entities: DspsNormalisedEntities;
}

interface DspsState {
    dsps: DspsInternalState;
}

interface IDsp {
    id?: number;
    name?: string;
    website?: string;
    format?: string;
    status?: number;
    type?: number;
    createdAt?: Date;
    updatedAt?: Date;
    deletedAt?: Date;
}

const DspRecord = Record({
    id: undefined,
    name: undefined,
    website: undefined,
    format: undefined,
    status: undefined,
    type: undefined,
    createdAt: undefined,
    updatedAt: undefined,
    deletedAt: undefined,
});

class Dsp extends DspRecord implements IDsp {
    public id: number;
    public name: string;
    public website: string;
    public format: string;
    public status: number;
    public type: number;
    public createdAt: Date;
    public updatedAt: Date;
    public deletedAt: Date;
}

interface DspsNormalisedEntities {
    dsps?: Map<number, Dsp>;
}

export {
    IDsp,
    Dsp,
    DspsNormalisedEntities,
    DspsInternalState,
    DspsState,
};
